// Normal builds: there is never a test seed (FR-017; research R9). The `.e2e.ts` variant replaces
// this file only in builds made with AKAIVA_E2E=1 (metro.config.js).
import type { E2eSeed } from "./types";

export function readSeed(): E2eSeed | null {
  return null;
}
